import { render } from "./LogoNameBrand.vue?vue&type=template&id=fd261bb2&scoped=true"
import script from "./LogoNameBrand.vue?vue&type=script&lang=js"
export * from "./LogoNameBrand.vue?vue&type=script&lang=js"

import "./LogoNameBrand.vue?vue&type=style&index=0&id=fd261bb2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd261bb2"]])

export default __exports__